import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import './i18n';
import '@/App.css';

// Contexts
import { AdminProvider } from '@/contexts/AdminContext';

// Components
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import CookieBanner from '@/components/CookieBanner';
import AdminOnlyGuard from '@/components/AdminOnlyGuard';

// Pages
import HomePage from '@/pages/HomePage';
import EventsPage from '@/pages/EventsPage';
import EventDetailPage from '@/pages/EventDetailPage';
import GalleryPage from '@/pages/GalleryPage';
import AboutPage from '@/pages/AboutPage';
import ContactPage from '@/pages/ContactPage';
import PrivacyPolicy from '@/pages/PrivacyPolicy';
import CookiePolicy from '@/pages/CookiePolicy';
import TermsOfService from '@/pages/TermsOfService';
import CorsoOsmand from '@/pages/CorsoOsmand';

// Admin Pages
import AdminLogin from '@/pages/admin/AdminLogin';
import AdminDashboard from '@/pages/admin/AdminDashboard';
import AdminEventForm from '@/pages/admin/AdminEventForm';
import AdminBookings from '@/pages/admin/AdminBookings';
import AdminMedia from '@/pages/admin/AdminMedia';
import AdminPayments from '@/pages/admin/AdminPayments';
import AdminGalleries from '@/pages/admin/AdminGalleries';
import AdminCountries from '@/pages/admin/AdminCountries';
import AdminStatistics from '@/pages/admin/AdminStatistics';
import AdminCorso from '@/pages/admin/AdminCorso';
import AdminAnalytics from '@/pages/admin/AdminAnalytics';

function App() {
  return (
    <AdminProvider>
      <BrowserRouter>
        <div className="App min-h-screen flex flex-col">
          <Navbar />
          <main className="flex-grow">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/events" element={<EventsPage />} />
              <Route path="/eventi" element={<EventsPage />} />
              <Route path="/eventi/:country" element={<EventsPage />} />
              <Route path="/events/:eventId" element={<EventDetailPage />} />
              <Route path="/evento/:eventId" element={<EventDetailPage />} />
              <Route path="/eventi/evento/:eventId" element={<EventDetailPage />} />
              <Route path="/gallery" element={<GalleryPage />} />
              <Route path="/galleria" element={<GalleryPage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/corso-osmand" element={<CorsoOsmand />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/cookie-policy" element={<CookiePolicy />} />
              <Route path="/terms" element={<TermsOfService />} />
              
              {/* Admin Routes */}
              <Route path="/admin/login" element={<AdminLogin />} />
              
              {/* Admin-only routes (blocked for tech users) */}
              <Route path="/admin/dashboard" element={<AdminOnlyGuard><AdminDashboard /></AdminOnlyGuard>} />
              <Route path="/admin/bookings" element={<AdminOnlyGuard><AdminBookings /></AdminOnlyGuard>} />
              <Route path="/admin/media" element={<AdminOnlyGuard><AdminMedia /></AdminOnlyGuard>} />
              <Route path="/admin/payments" element={<AdminOnlyGuard><AdminPayments /></AdminOnlyGuard>} />
              <Route path="/admin/countries" element={<AdminOnlyGuard><AdminCountries /></AdminOnlyGuard>} />
              <Route path="/admin/corso" element={<AdminOnlyGuard><AdminCorso /></AdminOnlyGuard>} />
              <Route path="/admin/events/new" element={<AdminOnlyGuard><AdminEventForm /></AdminOnlyGuard>} />
              <Route path="/admin/events/edit/:eventId" element={<AdminOnlyGuard><AdminEventForm /></AdminOnlyGuard>} />
              
              {/* Routes accessible by both admin and tech */}
              <Route path="/admin/galleries" element={<AdminGalleries />} />
              <Route path="/admin/statistics" element={<AdminStatistics />} />
              <Route path="/admin/analytics" element={<AdminAnalytics />} />
              
              <Route path="/admin" element={<Navigate to="/admin/dashboard" replace />} />
            </Routes>
          </main>
          <Footer />
          <CookieBanner />
        </div>
      </BrowserRouter>
    </AdminProvider>
  );
}

export default App;
